<template>
 <div class="g-flex-centered g-bg-img-hero g-bg-pos-top-center g-bg-cover g-bg-bluegray-opacity-0_2--after" style="background-image: url('../../../../static/assets/img/bg/Portal Photo_KidImage4.jpeg'); background-position: center" data-calc-target="#js-header">
    <div class="container g-pos-rel g-z-index-1">
        <div class="u-shadow-v36 g-max-width-500 g-bg-main-light-v1 g-pa-50 g-mt-130 g-mb-100">
        <div class="g-mb-10">
            <h1 class="g-color-white g-font-size-40--md mb-3">Resources</h1>
            <p class="g-color-white-opacity-0_8 g-font-size-20">Want to get involved, but aren’t sure where to start?  Check out these helpful guides and useful educational tools to explore ways to get engaged in your community.</p>
        </div>
        </div>
        <div class="text-center g-py-20">
            <a v-on:click="ArrowDown()" class="g-color-main g-color-primary--hover"><span><i class="fa fa-chevron-down" style="font-size: 30px"></i></span></a>
        </div>
    </div>
</div>
</template>
<script>
export default {
  methods:{
    ArrowDown() {
        this.$scrollTo("#errorDiv", 300, {
                        el: "#errorDiv",
                        offset: -100,
                        x: false,
                        y: true
                    });
    }
    }
}
</script>



// WEBPACK FOOTER //
// ResourcePromo.vue?c29b9118